import React from 'react';
import { Chip, Typography } from '@material-ui/core';

export const GuaranteedGainsField = ({ record }) => {
  if (!record?.guaranteed_gains) {
    return <span>-</span>;
  }

  return (
    <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
      <Chip label="GG" size="small" color="primary" style={{ marginBottom: 4 }} />
      <Typography variant="caption">
        {record.guaranteed_gains_current || 0} / {record.guaranteed_gains_max || 0}
      </Typography>
    </div>
  );
};

export default GuaranteedGainsField;
